export type SingleValueConfig = {
  value: string
}

export function isSingleValueConfig(config: unknown): config is SingleValueConfig {
  return typeof config === 'object' && config !== null && config !== undefined && 'value' in config
    && typeof config.value === 'string'
}